import Vue from 'vue';

import store from './store.js';
import router from './router.js';
import appHeader from './app-header.vue';

export const initHeader = () => {
  const app = document.getElementById('app-header');
  if (!app) return;
  const nav = app.dataset.nav && JSON.parse(app.dataset.nav);
  const designTheme = app.dataset.designTheme;

  if (app) {
    new Vue({
      store,
      router,
      render: (createEl) => createEl(appHeader, { props: { nav, designTheme } }),
    }).$mount('#app-header');
  }
};
